import { Controller } from "@hotwired/stimulus"
import "codemirror"
import "codemirror/modes/htmlmixed"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"
import { show_error, show_success, scrollToContainer, dataTruncate } from "lib/helpers"

// mailing/index + mailing/new — data-controller="mailing"
export default class extends Controller {
  static targets = ["table", "templateEditor", "workspace"]

  static values = {
    templateEditPath: String,
    mailPreviewPath: String,
  }

  connect() {
    if (this.hasTemplateEditorTarget) this.#initCodeMirror()
    if (this.hasTableTarget) this.#initDataTable()
  }

  disconnect() {
    if (this.dataTable) {
      this.dataTable = destroyTurboDataTable(this.dataTable)
    }
    if (this.codeMirror) {
      this.codeMirror.toTextArea()
      this.codeMirror = null
    }
  }

  mailPreview(event) {
    if (event) event.preventDefault()
    window.open(this.mailPreviewPathValue, "_blank")
  }

  sendMail(event) {
    if (event) event.preventDefault()

    $(".template-controls input").attr("disabled", true)

    $.get(this.mailPreviewPathValue, { format: "json" }, (response) => {
      if (response.success) {
        show_success(response.message, $("#workspace"))
      } else {
        show_error(response.message, $("#workspace"))
      }
      if (typeof scrollToContainer === "function") scrollToContainer()
    }).always(() => {
      $(".template-controls input").attr("disabled", false)
    })
  }

  saveChanges(event) {
    if (event) event.preventDefault()
    $("#activate").val(false)
  }

  #initCodeMirror() {
    this.codeMirror = CodeMirror.fromTextArea(this.templateEditorTarget, {
      mode: "htmlmixed",
      lineNumbers: true,
      theme: "default",
    })
  }

  #initDataTable() {
    this.dataTable = createTurboDataTable(this.tableTarget, {
      dom: "lrtip",
      pagingType: "full_numbers",
      cookiePrefix: "mailing_datatable_",
      processing: true,
      serverSide: true,
      stateSave: true,
      ajax: { url: "/mailing/data" },
      columnDefs: [
        {
          targets: 0,
          createdCell: (cell, cellData) => {
            const href = `${this.templateEditPathValue}/${cellData}/edit`
            $(cell).html(`<a href='${href}'>${dataTruncate(cellData, 15)}</a>`)
          },
        },
        { targets: [1, 2, 3, 4, 5], sortable: false },
      ],
    }, { legacy: true })
  }
}
